import { IRouteType } from '../../types'
import wingitnorthPAndL from '../common/pnl'
import wingitnorthPAndLConfig from '../common/pnlConfig'
import wingitnorthPAndLRankings from '../common/pnlRankings'
import storeHome from './storeHome'
import wingitnorthCorporateIntraday from './wingitnorthCorporateIntraday'
import wingitnorthDailyFlash from './wingitnorthDailyFlash'
import winditnorthDemo from './wingitnorthDemo'
import wingitnorthFinancialChart from './wingitnorthFinancialChart'
import wingitnorthGroupManagement from './wingitnorthGroupManagement'
import wingitnorthLocationManagement from './wingitnorthLocationManagement'
import wingitnorthOutliers from './wingitnorthOutliers'
import wingitnorthProduct from './wingitnorthProduct'
import wingitnorthSystemwideOverview from './wingitnorthSystemwideOverview'
import wingitnorthUploadReport from './wingitnorthUploadReport'

export const routes: IRouteType[] = [
  {
    title: 'Corporate',
    children: [
      {
        title: 'Systemwide Overview',
        link: '/:brand/systemwide_overview',
        default: true,
      },
      {
        title: 'Daily Flash',
        link: '/:brand/daily_flash',
        default: true,
      },
      {
        title: 'Demo',
        link: '/:brand/demo',
      },
      {
        title: 'Product',
        link: '/:brand/product',
      },
      {
        title: 'Outliers',
        link: '/:brand/outliers',
      },
      {
        title: 'Hourly Sales',
        link: '/:brand/hourly_sales',
      },
    ],
  },
  {
    title: 'Financial Chart',
    collapsible: true,
    children: [
      {
        title: 'Total Sales',
        link: '/:brand/sales_chart',
      },
      {
        title: 'SSS/SST/SSC',
        link: '/:brand/sss_chart',
      },
      {
        title: 'Check Average',
        link: '/:brand/check_average_chart',
      },
    ],
  },
  {
    title: 'Store',
    children: [
      {
        title: 'Home',
        link: '/:brand/scorecard',
      },
    ],
  },
  {
    title: 'P&L',
    children: [
      {
        title: 'Expo AI P&L',
        link: '/:brand/pnl',
      },
      {
        title: 'Expo AI P&L Rankings',
        link: '/:brand/pnl-rankings',
      },
      {
        title: 'Config',
        link: '/:brand/pnl-config',
        hideFromNavMenu: true,
      },
    ],
  },
  {
    title: 'Administration',
    children: [
      {
        title: 'Groups',
        link: '/:brand/groups',
      },
      {
        title: 'Locations',
        link: '/:brand/locations',
      },
      {
        title: 'Upload Reports',
        link: '/:brand/upload-reports',
      },
    ],
  },
]

export default [
  storeHome,
  wingitnorthDailyFlash,
  wingitnorthSystemwideOverview,
  winditnorthDemo,
  wingitnorthProduct,
  wingitnorthPAndL({
    brand: 'wingitnorth-only-for-qa',
    startDate: '2023-12-31',
  }),
  wingitnorthPAndLRankings({
    brand: 'wingitnorth-only-for-qa',
    startDate: '2023-12-31',
  }),
  wingitnorthPAndLConfig('wingitnorth-only-for-qa'),
  wingitnorthOutliers,
  wingitnorthFinancialChart,
  wingitnorthGroupManagement,
  wingitnorthLocationManagement,
  wingitnorthCorporateIntraday,
  wingitnorthUploadReport,
]
